// =========================
// lib/observeOnboarding.js   (PLATFORM-006 — ADR-064 Slice 2)
//
// Fire-and-forget client hook that asks the server-authoritative
// /api/observe-onboarding endpoint to observe the participant's onboarding
// lifecycle (account creation + first login) and publish the corresponding
// Product Domain Events. Called from AuthCallback once a session has settled.
//
// CONTRACT: this NEVER blocks or delays authentication/navigation, and it NEVER
// throws. It resolves the current session token and POSTs with it; any failure
// (no session, network error, non-OK response) is swallowed. Observation is
// idempotent + retried on the next login, so a missed call is self-healing.
// =========================

import { supabase } from './supabaseClient';
import { API_BASE_URL } from '../services/api';

export async function observeOnboarding() {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (!token) return;
    await fetch(`${API_BASE_URL}/observe-onboarding`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: '{}',
    });
  } catch {
    // Non-fatal by design: onboarding observation must never affect login.
  }
}
